import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { StatusInscricao } from '../models/status-inscricao'

@Injectable({
  providedIn: 'root',
})
export class ConsultaService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  statusInscricao(cpf: string, ano: number): Observable<StatusInscricao[]> {
    return this.http
      .get<StatusInscricao[]>(`${this.baseUrl}/consulta/status-inscricao/${cpf}/${ano}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
